import React from 'react'
import { withLayout } from '../../layout/layout'
import NotFound from '../../components/404/404'

const Journal = () => {
  return (
    <div><NotFound/></div>
  )
}

export default withLayout(Journal)